// extracted by mini-css-extract-plugin
export var title = "index-module--title--3B8ka";
export var subtitle = "index-module--subtitle--3H0Yd";
export var guideItemContent = "index-module--guideItemContent--mM79v";
export var centered = "index-module--centered--1lSd1";
export var infoHeaderContainer = "index-module--infoHeaderContainer--2K2I3";
export var guidePrice = "index-module--guidePrice--19mQE";
export var imgContainer = "index-module--imgContainer--xOiab";
export var btnGuideCta = "index-module--btnGuideCta--18ayC";
export var cardGuideCta = "index-module--cardGuideCta--1eDke";